/**
 * Cross-cutting constants. Mirrors mDenials-portal/src/config/constants.ts.
 */

export const QUERY_KEY = {
    SESSION: 'session',
    SESSIONS: 'sessions',
    PROGRESS: 'progress',
    REVISIONS: 'revisions',
    REVISION_DIFF: 'revision-diff',
} as const;
